import { useEffect } from 'react';
import { useSearchModal } from '@backstage/plugin-search';

/**
 * Component that registers a global keyboard shortcut (Command+K / Ctrl+K)
 * to toggle the search modal.
 *
 * This component must be rendered within a SearchModalProvider context
 * to access the toggleModal function.
 */
export const KeyboardShortcutHandler = () => {
  const { toggleModal } = useSearchModal();

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Check for Command+K (Mac) or Ctrl+K (Windows/Linux)
      // Only trigger with lowercase 'k' (no Shift key)
      if ((event.metaKey || event.ctrlKey) && event.key === 'k' && !event.shiftKey) {
        // Prevent default browser behavior (e.g., Chrome's address bar focus)
        event.preventDefault();
        toggleModal();
      }
    };

    // Register the keyboard event listener
    window.addEventListener('keydown', handleKeyDown);

    // Cleanup listener on unmount
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [toggleModal]);

  // This component doesn't render anything
  return null;
};
